import styles from "../styles/home.module.css";
import deadlift from "../assets/deadlift.jpeg";
import squat from "../assets/squat.jpg";
import bench from "../assets/bench-press.png";


export default function Home({ selectLift }) {
return (
<>
<h1>Select a Lift</h1>
<div className={styles.grid}>
<LiftCard name="Deadlift" img={deadlift} onClick={() => selectLift("deadlift")} />
<LiftCard name="Squat" img={squat} onClick={() => selectLift("squat")} />
<LiftCard name="Bench Press" img={bench} onClick={() => selectLift("bench")} />
</div>
</>
);
}


function LiftCard({ name, img, onClick }) {
return (
<div className={styles.card} onClick={onClick}>
<div className={styles.imageWrapper}>
<img src={img} alt={name} />
</div>
<h2 className={styles.liftName}>{name}</h2>
</div>
);
}